import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { ApiResponse } from '../shared/types';
import type { AppConfig } from '../rewards/models/rewards-v2.models';

/** GET /api/v1/user/app-config */
const APP_CONFIG_ENDPOINT = 'user/app-config';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  constructor(private readonly apiService: ApiService) {}

  getAppConfig(): Observable<AppConfig> {
    return this.apiService.get<AppConfig>(APP_CONFIG_ENDPOINT).pipe(
      map((response: ApiResponse<AppConfig>) => {
        if (response.status && response.data) {
          return response.data;
        }
        throw new Error(response.message || 'Failed to load app config');
      }),
      catchError(error => throwError(() => error))
    );
  }
}
